import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import LabConnectionTableDto from '../dto/LabConnectionTableDto';

class LabConnectionTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'labConnectionTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<LabConnectionTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, LabConnectionTableDto)))
				.catch(reject);
		});
	}
}

export default new LabConnectionTableService();
